export { default } from './star-filled'
